import { render } from "./Department.vue?vue&type=template&id=54c8ba5c&ts=true"
import script from "./Department.vue?vue&type=script&lang=ts"
export * from "./Department.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__